import http from "./httpService";
const apiEndpoint = "/metadata";

export function stripeCountries() {
    return http.get(apiEndpoint + "/countries" )
}
  

